export const DialogSpecialType = {
	bot: 'bot',
	extranet: 'extranet',
	network: 'network',
	collaber: 'collaber',
	support24: 'support24',
};

export const TitleIcons = {
	absent: 'absent',
	birthday: 'birthday',
};

export const ChatTitleType = {
	notes: 'notes',
};
